<ng-template #showValueOnly>
  <div
    class="text-nowrap"
    [class.quantity_label_style]="!!showQuantitySelectLabel"
  >
    <ng-container *ngIf="showQuantitySelectLabel">
      <ng-container i18n="@@product-list.header.product_quantity_subject">
        Menge:
      </ng-container>
    </ng-container>
    {{ _value }}
  </div>
</ng-template>

<ng-container [ngSwitch]="renderType">
  <ng-container *ngSwitchCase="'display'">
    <ng-container *ngTemplateOutlet="showValueOnly"></ng-container>
  </ng-container>
  <div *ngSwitchCase="'checkbox'" [class.checked]="checkboxState$ | async">
    <ng-container *ngIf="isReadonly && _value > 0; else showCheckboxInput">
      <ng-container *ngTemplateOutlet="showValueOnly"></ng-container>
    </ng-container>
    <ng-template #showCheckboxInput>
      <input
        [id]="radioButtonGroupName + product.product_id"
        type="checkbox"
        [class.readonly]="isReadonly"
        (click)="(isReadonly ? false : true)"
        [checked]="checkboxState$ | async"
        (change)="onChangeValue($any($event.target).checked ? 1 : 0)"
        [value]="_value"
      />
      <label
        class="input-checkbox"
        [for]="radioButtonGroupName + product.product_id"
      ></label>
    </ng-template>
  </div>

  <div *ngSwitchCase="'radiobutton'">
    <input
      [id]="radioButtonGroupName + product.product_id"
      type="radio"
      [checked]="checkboxState$ | async"
      (change)="onRadioChange(product.product_id)"
      [name]="radioButtonGroupName"
      [value]="true"
      [readonly]="this.isReadonly"
    />
    <label
      class="input-radio"
      [for]="radioButtonGroupName + product.product_id"
    ></label>
  </div>

  <div *ngSwitchCase="'input'" class="input">
    <ng-container *ngIf="showQuantitySelectLabel">
      <span
        class="quantity_label_style"
        i18n="@@product-list.header.product_quantity_subject"
        >Menge:
      </span>
    </ng-container>
    <select
      class="form-control"
      *ngIf="showSelect; else input"
      (change)="onChangeValue($any($event.target).value); onFocusIn()"
      #select
    >
      <option
        *ngFor="let quantity of selectValues"
        [value]="quantity.value"
        [attr.selected]="'' + _value === '' + quantity.value ? true : null"
        >{{ quantity.label }}</option
      >
    </select>
    <ng-template #input>
      <input
        class="form-control form-control-no-validation"
        type="number"
        (blur)="onInputFocusOut()"
        (input)="inputChange$.next($any($event.target).value)"
        [value]="_value"
        (focus)="onFocusIn()"
        size="3"
        #inputElement
      />
    </ng-template>
  </div>
  <div
    *ngIf="showPreQuantity && renderType !== 'display'"
    class="since"
    i18n="@@product-list.quantity-input.since"
  >
    bisher: {{ product.quantity.pre_quantity }}
  </div>
</ng-container>
